import React from "react";
import AssetPage from "./HR/Asset/Asset";

export default function AssetPageWrapper() {
  return (
    <div className="px-6 space-y-6 animate-in fade-in duration-300">
      <AssetPage />
    </div>
  );
}
